<div class="ripple" [style.top.px]="top" [style.left.px]="left" ></div>
